import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import "../styles/Header.css";
// import MenuPortalItem from "../MenuPortalItem";

function CookiesPolitics(props) {
  const handleCookies = () => {
    localStorage.setItem("coockies-accepted", new Date().getTime());

    //console.log("document.getElementById('CookieNotification')=", document.getElementById("CookieNotification"));
    document.getElementById("CookieNotification").setAttribute("style", "display:none!important");
  };

  return (
    <>
      <div className="offcanvas offcanvas-start text-muted fw-light" id="offcanvasCookiesPolitics" aria-labelledby="offcanvasExampleLabel">
        <div className="offcanvas-header bg-light pt-2 pb-2">
          <div className="d-flex flex-row align-items-center ">
            <img src="/assets/images/CBTKD_simbolo_cor.svg" alt="CBTKD" width="64px" />
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              Política de cookies
            </h5>
          </div>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <div className="container-fluid">
            <div className="accordion text-align-justify" id="accordionExample">
              <div className="accordion-item border-start-0 border-end-0">
                <h6 className="accordion-header p-0" id="headingOne">
                  <button
                    className="accordion-button ps-0 pe-0 bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    O que são cookies?
                  </button>
                </h6>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body ps-0 pe-0">
                    <p>
                      Cookies são arquivos salvos em seu computador, tablet ou telefone quando você visita um site. Usamos os cookies
                      necessários para fazer o site funcionar da melhor forma possível e sempre aprimorar os nossos serviços.
                    </p>
                    <p>
                      Alguns cookies são classificados como necessários e permitem a funcionalidade central, como segurança, gerenciamento
                      de rede e acessibilidade. Estes cookies podem ser coletados e armazenados assim que você inicia sua navegação ou
                      quando usa algum recurso que os requer.
                    </p>
                  </div>
                </div>
              </div>

              <div className="accordion-item border-start-0 border-end-0">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed ps-0 pe-0 bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Cookies Primários
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body ps-0 pe-0">
                    <p>
                      Alguns cookies serão colocados em seu dispositivo diretamente pelo nosso site - são conhecidos como cookies primários.
                      Eles são essenciais para você navegar no site e usar seus recursos.
                    </p>
                    <h6>Temporários</h6>
                    <p>
                      Nós utilizamos cookies de sessão. Eles são temporários e expiram quando você fecha o navegador ou quando a sessão
                      termina.
                    </p>
                    <div className="alert alert-dark" role="alert">
                      <h6>Finalidade</h6>
                      Estabelecer controle de idioma e segurança ao tempo da sessão.
                    </div>
                    <hr />
                    <h6>Persistentes</h6>
                    <p>
                      Utilizamos também cookies persistentes que permanecem em seu disco rígido até que você os apague ou seu navegador o
                      faça, dependendo da data de expiração do cookie. Todos os cookies persistentes têm uma data de expiração gravada em
                      seu código, mas sua duração pode variar.
                    </p>
                    <div className="alert alert-dark" role="alert">
                      <h6>Finalidade</h6>
                      Coletam e armazenam a ciência sobre o uso de cookies no site.
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item border-start-0 border-end-0">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed ps-0 pe-0 bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Cookies de Terceiros
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body ps-0 pe-0">
                    <p>
                      Outros cookies são colocados no seu dispositivo não pelo site que você está visitando, mas por terceiros, como, por
                      exemplo, os sistemas analíticos.
                    </p>
                    <h6>Temporários</h6>
                    <p>
                      Nós utilizamos cookies de sessão. Eles são temporários e expiram quando você fecha o navegador ou quando a sessão
                      termina.
                    </p>
                    <h6>Finalidade</h6>
                    <p>
                      Coletam informações sobre como você usa o site, como as páginas que você visitou e os links em que clicou. Nenhuma
                      dessas informações pode ser usada para identificá-lo. Seu único objetivo é possibilitar análises e melhorar as funções
                      do site.
                    </p>
                    <hr />
                    <h6>Persistentes</h6>
                    <p>
                      Utilizamos também cookies persistentes que permanecem em seu disco rígido até que você os apague ou seu navegador o
                      faça, dependendo da data de expiração do cookie. Todos os cookies persistentes têm uma data de expiração gravada em
                      seu código, mas sua duração pode variar.
                    </p>
                    <div className="alert alert-dark" role="alert">
                      <h6>Finalidade</h6>
                      Coletam informações sobre como você usa o site, como as páginas que você visitou e os links em que clicou. Nenhuma
                      dessas informações pode ser usada para identificá-lo. Seu único objetivo é possibilitar análises e melhorar as funções
                      do site.
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <p>
                Você pode desabilitá-los alterando as configurações do seu navegador, mas saiba que isso pode afetar o funcionamento do
                site.
              </p>
              <a
                className="text-decoration-none"
                href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=pt-BR"
              >
                Chrome
              </a>
              <br />
              <a className="text-decoration-none" href="">
                Firefox
              </a>
              <br />
              <a className="text-decoration-none" href="">
                Microsoft Edge
              </a>
              <br />
              <a className="text-decoration-none" href="">
                Internet Explorer
              </a>
              <br />
            </div>
          </div>
        </div>
        <div className="stick-bootom">
          <hr />
          <div className="d-flex justify-content-center pb-3">
            <button type="button" className="btn btn-primary" onClick={handleCookies} data-bs-dismiss="offcanvas" aria-label="Close">
              Aceito
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CookiesPolitics;
